const APP_VERSION = '1775581762538';
export default APP_VERSION;
